import { render, staticRenderFns } from "./ImportPhoto.vue?vue&type=template&id=21bc770c&scoped=true"
import script from "./ImportPhoto.vue?vue&type=script&lang=js"
export * from "./ImportPhoto.vue?vue&type=script&lang=js"
import style0 from "./ImportPhoto.vue?vue&type=style&index=0&id=21bc770c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc770c",
  null
  
)

export default component.exports